import type { SelectChangeEvent } from '@mui/material';
import { MenuItem, Select } from '@mui/material';
import type { DatasourceType } from '../../model/types';
import { DATASOURCE_TYPE_LABEL_MAP } from '../DatasourceCard/DatasourceCard';

const TYPES_COUNT = Object.keys(DATASOURCE_TYPE_LABEL_MAP).length;
const SORTED_TYPE_ENTRIES = Object.entries(DATASOURCE_TYPE_LABEL_MAP).sort(
  ([, a], [, b]) => a.localeCompare(b),
);

interface Props {
  value: DatasourceType[];
  onChange: (v: DatasourceType[]) => void;
}

export function SourceTypeSelect({ value, onChange }: Props) {
  const handleDatasourceTypesChange = (
    event: SelectChangeEvent<DatasourceType[]>,
  ) => {
    const {
      target: { value },
    } = event;

    onChange(value as DatasourceType[]);
  };
  return (
    <Select
      sx={{
        width: 145,
        borderRadius: 2,
        color: value.length > 0 ? '#343844' : '#7E828F',
      }}
      displayEmpty
      multiple
      renderValue={(value) => {
        return `Source type ${
          value.length > 0 && value.length < TYPES_COUNT
            ? `(${value.length})`
            : ''
        }`;
      }}
      value={value}
      onChange={handleDatasourceTypesChange}
      MenuProps={{
        slotProps: {
          paper: {
            sx: { borderRadius: 2 },
          },
        },
        MenuListProps: {
          disablePadding: true,
        },
      }}
    >
      {SORTED_TYPE_ENTRIES.map(([value, label]) => {
        return (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        );
      })}
    </Select>
  );
}
